import { Database } from "@/utils/supabase/types";

export * from "@lib/constants/constants";
export const USER_KIND = {
  member: "member",
  employer: "employer",
  healthInsuranceSocietyStaff: "health_insurance_society_staff",
} as const;
export type UserKind = (typeof USER_KIND)[keyof typeof USER_KIND];

/**
 * パスワードに利用出来る記号
 * これをベースにバリデーションを行っている訳ではなく実際にはsupabase内部のルールに依存している
 */
export const AVAILABLE_SPECIAL_CHARACTERS_FOR_PASSWORD = `+/.!"#$%&'()*-,;:<=>?@¥[]_{}|^`;

/**
 * UBS基幹システムのコード
 * https://docs.google.com/spreadsheets/d/1h4qIHgk5L9BHXQg3ZzA69A5o38QdK3iqHY6N81pmO0o/edit#gid=74457349
 * https://docs.google.com/spreadsheets/d/1s1O4EKQcFLMgY0C-sOXmOdeaP1m1a-tm6g9BJ4nrAFY/edit#gid=2024025792&range=H21
 * https://docs.google.com/spreadsheets/d/1s1O4EKQcFLMgY0C-sOXmOdeaP1m1a-tm6g9BJ4nrAFY/edit#gid=2024025792&range=E44
 */
export const UBS_SYSTEM_CODE = {
  sex: {
    "5": "男性",
    "6": "女性",
  },
  livingTogether: {
    "0": "同居",
    "1": "別居",
  },
  longTermCareCategory: {
    ["第二号"]: "第二号",
    ["特定"]: "特定",
    ["第一号"]: "第一号",
    ["特定一号"]: "特定一号",
    ["未使用"]: "未使用",
  },
  premiumExemptionType: {
    ["育児休業"]: "育児休業",
    ["産休"]: "産休",
    ["法１５８条"]: "法１５８条",
  },
} as const;

export type EmployerStatus = Database["public"]["Enums"]["employer_status"];

export const employerStatusRepresentations: Record<
  EmployerStatus | "inviting" | "invitation_expired" | "deleted",
  string
> = {
  active: "アクティブ",
  inviting: "招待中",
  deleted: "削除済み",
  invitation_expired: "招待期限切れ",
} as const;

export const MEMBER_RELATIONSHIPS: Database["public"]["Enums"]["relationship"][] =
  [
    "11",
    "12",
    "13",
    "14",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2A",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3A",
    "41",
    "42",
    "43",
    "44",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "71",
    "72",
    "73",
    "74",
    "81",
    "82",
    "83",
    "84",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "9A",
  ] as const;

// Postgresのエラーコード
// https://www.postgresql.jp/docs/14/errcodes-appendix.html
export const POSTGRES_UNIQUE_VIOLATION = "23505";

// // 健保スタッフのメールアドレスドメイン
export const KENPO_DOMAIN = "startupkenpo.com" as const;

// 連打対策でボタンを無効化する時間（ミリ秒）
export const DISABLE_BUTTON_DURATION_MS = 1000;

// パスワードは最大72文字まで
// https://github.com/supabase/auth/pull/1368
export const MAX_PASSWORD_LENGTH = 72;

// SendGridのリトライキューの最大リトライ回数
export const SENDGRID_RETRY_QUEUE_MAX_RETRY_COUNT = 10;

export const BOM = "\uFEFF";

export const ELIGIBILITY = {
  insured: "加入中",
  optional_and_continued: "任意継続中",
  lost_eligibility: "資格喪失",
} as const;

// CSVインポートで同期しない事業所の記号
export const UNSYNCED_OFFICE_CODES = [
  "00000", // 動作確認用事業所
];

// 削除済みレコードの保存期間（日数）
export const DELETED_RECORDS_RETENTION_DAYS = 90;

// ゆうちょ銀行の銀行コード
export const YUCHO_BANK_CODE = "9900";
